import TextUtil from './text.util';

export default {
  TextUtil,
};
